import React, { useState } from "react";
import {
    Typography,
    Button,
    Divider,
    Box,
    Grid,
} from "@mui/material";
// import logo from "../10/SCHOOL/logo.jpg"
import { useLocation } from "react-router-dom";

const MarksheetReceipt = () => {
    const location = useLocation();
    const { receiptData } = location.state || {};
    const [showPrintButton, setShowPrintButton] = useState(true);

    const handlePrint = () => {
        setShowPrintButton(false);
        sessionStorage.setItem("hide", true);
        setTimeout(() => {
            window.print();
            setShowPrintButton(true);
        }, 100);
    };

    const toCamelCase = (str) => {
        return str
            ?.toLowerCase()
            .replace(/[^a-zA-Z0-9 ]/g, '')
            .split(' ')
            .map((word, index) =>
                index === 0
                    ? word.charAt(0).toUpperCase() + word.slice(1)
                    : word.charAt(0).toUpperCase() + word.slice(1)
            )
            .join(' ');
    };
    return (
        <>
            {receiptData?.map((ms) => (<>
                <Box key={ms.id}
                    sx={{
                        maxWidth: "800px",
                        margin: "auto",
                        px: 4,
                        pb: 4,
                        border: "2px solid #e6e6e6ff",
                        borderRadius: "12px",
                        backgroundColor: "#fff",

                    }}

                    style={{
                        // width: "100%",
                        // borderCollapse: "collapse",
                        backgroundImage: `url(${ms.logo})`,
                        // backgroundSize: "150px auto",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        backgroundColor: "rgb(255 255 255 / 87%)", // white overlay
                        backgroundBlendMode: "lighten"            // makes logo faint
                    }}

                >
                    {/* Header with Logo */}
                    <Box display="flex" alignItems="center" justifyContent="flex-start" flexDirection={'column'} >
                        <img
                            src={ms.logo} // replace with your logo path
                            alt="School Logo"
                            style={{ width: 80, height: 70, marginTop: 10 }}
                        />
                        <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                            {ms.schoolName}
                        </Typography>
                        <Typography sx={{ pb: 1 }}>
                            {ms?.address}
                        </Typography>
                        <Typography
                            variant="h6"
                            sx={{
                                bgcolor: "#f0f0f0",
                                borderRadius: 8,
                                fontWeight: "bold",
                                px: 2,
                                py: 0.2,
                                borderBottom: "3px solid #9e9d9dff",
                                borderLeft: "2px solid #9e9d9dff",
                                borderRight: "1px solid #9e9d9dff",
                                mb: 2
                            }}
                        >
                            {"MARKS STATEMENT"}
                        </Typography>

                    </Box>
                    <Box spacing={2} display="flex" justifyContent="space-between">
                        <Typography variant="body2">
                            Roll No: <b>{ms.receiptNumber}</b>
                        </Typography>
                        <Typography> {toCamelCase(`${ms.examType}`)} {ms.academicYear}</Typography>
                    </Box>

                    <Divider sx={{ mb: 2, mt: 1 }} />

                    {/* Student & Payment Info */}
                    <Grid container spacing={2} display="flex" justifyContent="space-between">
                        <Typography><b>Student Name:</b> {toCamelCase(`${ms.studentName}`)}</Typography>
                        <Typography><b>Standard:</b> {ms.classRoom.standard} | {ms.classRoom.section}</Typography>
                    </Grid>
                    <Divider sx={{ mb: 2, mt: 1 }} />
                    {/* <Table size="small">
                        <TableHead>
                            <TableRow sx={{ background: "#f0f0f0", borderCollapse: "collapse" }}>
                                <TableCell sx={{ border: "1px solid #000", padding: "8px" }}>#</TableCell>
                                <TableCell sx={{ border: "1px solid #000", padding: "8px" }}>Subject</TableCell>
                                <TableCell sx={{ border: "1px solid #000", padding: "8px" }}>Marks Obtained</TableCell>
                                <TableCell sx={{ border: "1px solid #000", padding: "8px" }}>Max Marks</TableCell>
                                <TableCell sx={{ border: "1px solid #000", padding: "8px" }}>Grade</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {ms?.marks.map((m, index) => (
                                <TableRow key={m.id}>
                                    <TableCell sx={{ border: "1px solid #000", padding: "8px" }}>{index + 1}</TableCell>
                                    <TableCell sx={{ border: "1px solid #000", padding: "8px" }}>{toCamelCase(`${m.subjectName}`)}</TableCell>
                                    <TableCell sx={{ border: "1px solid #000", padding: "8px" }}>{m.marksObtained}</TableCell>
                                    <TableCell sx={{ border: "1px solid #000", padding: "8px" }}>{m.maxMark}</TableCell>
                                    <TableCell sx={{ border: "1px solid #000", padding: "8px" }}>{m.grade}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        <TableFooter>
                            <TableRow sx={{ background: "#f0f0f0", borderCollapse: "collapse" }}>
                                <TableCell></TableCell>
                            </TableRow>
                        </TableFooter>
                    </Table> */}

                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        <thead>
                            <tr style={{ background: "#f0f0f079" }}>
                                <th style={{ border: "1px solid #000", padding: "8px" }}>#</th>
                                <th style={{ border: "1px solid #000", padding: "8px" }}>Subject</th>
                                <th style={{ border: "1px solid #000", padding: "8px" }}>Marks Obtained</th>
                                <th style={{ border: "1px solid #000", padding: "8px" }}>Max Marks</th>
                                <th style={{ border: "1px solid #000", padding: "8px" }}>Grade</th>
                            </tr>
                        </thead>
                        <tbody>
                            {ms?.marks.map((m, index) => (
                                <tr key={index}>
                                    <td style={{ border: "1px solid #000", padding: "8px", textAlign: "center" }}>
                                        {index + 1}
                                    </td>
                                    <td style={{ border: "1px solid #000", padding: "8px" }}>{toCamelCase(`${m.subjectName}`)}</td>
                                    <td style={{ border: "1px solid #000", padding: "8px", textAlign: "right" }}>
                                        {m.marksObtained}
                                    </td>
                                    <td style={{ border: "1px solid #000", padding: "8px", textAlign: "right" }}>
                                        {m.maxMark}
                                    </td>
                                    <td style={{ border: "1px solid #000", padding: "8px", textAlign: "right" }}>
                                        {m.grade}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr style={{ background: "#f0f0f079" }}>
                                <td colSpan="2" style={{ border: "1px solid #000", padding: "8px", textAlign: "right" }}>
                                    <b>Result: </b> {ms.result ? ms.result : "Fail"}
                                </td>
                                <td colSpan="1" style={{ border: "1px solid #000", padding: "8px", textAlign: "right" }}>
                                    <b>{ms.marks.reduce((sum, m) => sum + Number(m.maxMark || 0), 0)}</b>
                                </td>
                                <td style={{ border: "1px solid #000", padding: "8px", textAlign: "right" }}>
                                    <b>{ms.totalMarks}</b>
                                </td>
                                <td style={{ border: "1px solid #000", padding: "8px", textAlign: "right" }}>
                                    <b>{ms.grade}</b>
                                </td>
                            </tr>
                        </tfoot>
                    </table>

                    <Box variant="body1" sx={{ my: 2 }} display="flex" justifyContent="space-between">
                        <Typography variant="body2"><strong>Total Marks:</strong> {ms.totalMarks}/{ms.marks.reduce((sum, m) => sum + Number(m.maxMark || 0), 0)}</Typography>
                        <Typography variant="body2"><strong>Percentage:</strong> {ms.percentage.toFixed(2)}%  {" "}</Typography>
                        <Typography variant="body2"><strong>Grade:</strong> {ms.grade}</Typography>
                    </Box>
                    <Typography variant="body1" color="textSecondary">
                        <b>Remarks: </b>{ms.remarks}
                    </Typography>
                    <Box my={8} display="flex" justifyContent="space-between">
                        <Typography variant="body2">Signature: ___________________</Typography>
                        <Typography variant="body2">Class Teacher Sign.: ___________________</Typography>
                        <Box>
                            <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                                Principal/HeadMaster </Typography>
                            <Typography variant="body2">Seal/Sign.: ___________________</Typography>
                        </Box>
                    </Box>
                </Box>

                {showPrintButton && (
                    <Box textAlign="center" mt={3}>
                        <Button variant="contained" sx={{ bgcolor: "#3f2d01", borderRadius: 5 }} onClick={handlePrint}>
                            Print Marksheet
                        </Button>
                    </Box>
                )}
            </>))}
        </>
    );
};

export default MarksheetReceipt;
